import React from "react"
import styles from "./location.css"

const Location = (props) => {

    return (
        <section className="location" id="venue">
            <div className="gridContainvenue">
                <div className="gridVenue">
                    <h1>VENUE</h1>
                    <div className="venueName">SNG HQ</div>
                    <p className="undervenue">
                        2001 K Street NW
                        <br />
                        Washington, D.C. 20006
                    </p>
                </div>
                <div className="gridMap">
                <iframe src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d12419.660409380362!2d-77.0452025!3d38.9030567!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0xd3054cbe5fc858da!2sScoop%20News%20Group!5e0!3m2!1sen!2sus!4v1579793806272!5m2!1sen!2sus" className="mapGoogle darkmap"></iframe>
                </div>
                
                
            </div>
            
        </section>
    )
}

export default Location